import React from "react";
import PortfolioItem from "./PortfolioItem";
import { projectsData } from "../data/projectsData";

const PortfolioSection = () => {
  // Lấy 2 dự án đầu và map sang cấu trúc cũ
  const projects = projectsData.slice(0, 2).map((project) => ({
    title: project.title,
    category: project.categories,
    desc: project.shortDescription,
    img: project.hoverImg,
    link: `/du-an/${project.slug}`, // link chi tiết theo slug
  }));

  return (
    <section className="portfolio-section fix section-bg section-padding">
      <div className="container">
        {/* Tiêu đề */}
        <div className="section-title-area">
          <div className="section-title">
            <h6 className="wow fadeInUp">Danh Mục Dự Án</h6>
            <h2
              className="wow fadeInUp"
              data-wow-delay=".3s"
            >
              Một số <span>dự án gần đây</span>
            </h2>
          </div>
          <a
            href="/du-an"
            className="theme-btn wow fadeInUp"
            data-wow-delay=".5s"
          >
            Xem thêm
          </a>
        </div>

        {/* Danh sách dự án */}
        <div className="row">
          {projects.map((project, i) => (
            <div
              className="col-lg-12"
              key={i}
            >
              <PortfolioItem project={project} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PortfolioSection;
